module.exports = __webpack_public_path__ + "img/exit.c18d83ff.svg";